import React, { useEffect, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { Calendar, LocaleConfig } from 'react-native-calendars';
import colors from '../../../../config/colors';
import ImageIcon from '../../../../components/shared/Icon/ImageIcon.component';

LocaleConfig.locales['he'] = {
	monthNames: [
		'ינואר',
		'פברואר',
		'מרץ',
		'אפריל',
		'מאי',
		'יוני',
		'יולי',
		'אוגוסט',
		'ספטמבר',
		'אוקטובר',
		'נובמבר',
		'דצמבר',
	],
	monthNamesShort: [
		'ינו',
		'פבר',
		'מרץ',
		'אפר',
		'מאי',
		'יונ',
		'יול',
		'אוג',
		'ספט',
		'אוק',
		'נוב',
		'דצמ',
	],
	dayNames: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
	dayNamesShort: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'],
	//today: 'היום',
};
LocaleConfig.defaultLocale = 'he';

const CustomDatePicker = ({onDateChange, isRange = false }: any) => {
	const [selected, setSelected] = useState({});
	const [startDate, setStartDate] = useState<string | null>(null);
	const [endDate, setEndDate] = useState<string | null>(null);

	const getMarkedDates = () => {
		if (!isRange) {
			return selected;
		}

		if (!startDate || !endDate) {
			return {};
		}

		const marked: any = {};
		const start = new Date(startDate + 'T00:00:00Z');
		const end = new Date(endDate + 'T00:00:00Z');
		const current = new Date(start);

		while (current <= end) {
			const dateString = current.toISOString().split('T')[0];

			if (dateString === startDate) {
				
				marked[dateString] = {
					endingDay: true,
					color: colors.datepickerChooseBG,
					textColor: '#ffffff',
				};
			} else if (dateString === endDate) {
				marked[dateString] = {
					startingDay: true,
					color: colors.datepickerChooseBG,
					textColor: '#ffffff',
				};
			} else {
				marked[dateString] = {
					color: colors.iconBG,
					textColor: colors.darkGrey,
				};
			}

			 current.setUTCDate(current.getUTCDate() + 1);
		}

		return marked;
	};

	const handleDayPress = (day: any) => {

		if (!isRange) {
			// Single date mode
			setSelected({
				[day.dateString]: {
					selected: true,
				},
			});
			// Pass the selected day back to parent
			onDateChange({
				day: day.day,
				month: day.month,
				year: day.year,
				dateString: day.dateString,
			});
		} else {
        	const selectedDate = new Date(day.dateString + 'T00:00:00Z');
			const endDateCalc = new Date(selectedDate);
        	endDateCalc.setUTCDate(endDateCalc.getUTCDate() + 6);

			const endDateString = endDateCalc.toISOString().split('T')[0];
			setStartDate(day.dateString);
			setEndDate(endDateString);
			
			// Pass the week range back to parent
			onDateChange({
				startDate: day.dateString,
				endDate: endDateString,
			});
		}
	};

	const renderArrow = (direction: 'left' | 'right') => {
		return (
			<ImageIcon name={direction === 'left' ? 'chevLeft' : 'chevRight'} />
		);
	};

	return (
		<View style={styles.container}>
			<View style={styles.calendarWrapper}>
				<Calendar
					renderArrow={renderArrow}
					onDayPress={handleDayPress}
					markedDates={getMarkedDates()}
					firstDay={0}
					markingType={isRange ? 'period' : undefined}
					hideExtraDays={true}
					theme={{
						calendarBackground: colors.datepickerBG,
						textSectionTitleColor: colors.darkGrey,
						//selectedDayBackgroundColor: colors.datepickerChooseBG,
						//selectedDayTextColor: '#ffffff',
						dayTextColor: colors.darkGrey,
						textDisabledColor: '#adb5bd',
						monthTextColor: colors.darkGrey,
						//textMonthFontWeight: '600',
						//textMonthFontSize: 30,
						//textDayFontSize: 24,
						textDayHeaderFontSize: 15,
						textDayHeaderFontWeight: '600',
						//arrowColor: '#a74f4fff',
						'stylesheet.calendar.header': {
							header: {
								flexDirection: 'row',
								justifyContent: 'space-between',
								paddingHorizontal: 16,
								paddingVertical: 11,
								marginBottom: 16,
								alignItems: 'center',
							},
							arrow: {
								// backgroundColor: "red",
								// color: "black",
								// padding: 10,
							},
							// arrowImage: {
							// 	tintColor: '#990000ff',
							// 	backgroundColor: "red",
							// 	width: 20,
							// 	height: 20,
							// },
							monthText: {
								fontSize: 15,
								fontWeight: '400',
								color: colors.titlePrimary,
								// paddingHorizontal: 16,
								// paddingVertical: 11,
							},
							week: {
								marginTop: 7,
								flexDirection: 'row-reverse',
								justifyContent: 'space-around',
								borderBottomWidth: 1,
								borderBottomColor: colors.secondaryLight,
							},
						},
						'stylesheet.calendar.main': {
							week: {
								marginTop: 7,
								marginBottom: 7,
								flexDirection: 'row-reverse',
								justifyContent: 'space-around',
							},
						},
						'stylesheet.day.basic': {
							base: {
								width: 34,
								height: 34,
								alignItems: 'center',
								justifyContent: 'center',
							},
							selected: {
								backgroundColor: colors.datepickerChooseBG,
								borderRadius: 4,
							},
							today: {
								backgroundColor: 'transparent',
							},
							todayText: {
								color: colors.darkGrey,
							},
						},
						'stylesheet.day.period': {
							base: {
								width: 34,
								height: 34,
								alignItems: 'center',
								justifyContent: 'center',
							},
							selected: {
								backgroundColor: colors.datepickerChooseBG,
							},
							todayText: {
								color: colors.darkGrey,
							},
							// today: {
							// 	backgroundColor: 'transparent',
							// },
							// text: {
							// 	fontWeight: '400',
							// 	zIndex: 10,
							//      color: colors.darkGrey,
							// },
							// selectedText: {
							//     color: '#ffffff',
							//     fontWeight: '400',
							// },
						},
					}}
					style={styles.calendar}
					enableSwipeMonths={false}
				/>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		//padding: 16,
	},
	calendarWrapper: {
		borderRadius: 8,
		padding: 16,
		width: 310,
		minHeight: 430,
		backgroundColor: colors.datepickerBG,
	},
	calendar: {
		borderRadius: 8,
		width: '100%',
		//height: 420
	},
});

export default CustomDatePicker;
